export default "{\n    \"title\": \"Modifier la maintenance planifiée\",\n    \"name\": \"Nom\",\n    \"submitLabel\": \"Enregistrer\"\n}\n"